<template>
	<div class="md-layout">
		<div class="md-layout-item md-small-size-100">
			<form-card
				title="Ajout d'un secteur"
				icon="add"
				v-model="name"
				:goBack="goBack"
				:save="addSector"
				:error="error">
			</form-card>
		</div>
	</div>
</template>

<script>
import FormCard from "@/pages/Configuration/components/FormCard";

export default {
	name: "SectorAdd",
	components: { FormCard },
	data() {
		return {
			name: null,
			error: null
		}
	},
	methods: {
		goBack() {
			this.$router.go(-1);
		},
		async addSector() {
			if(this.name) {
				let sector = {
					name: this.name.toUpperCase()
				}
				try {
					this.error = null
					await this.$store.dispatch('sectors/addSector', sector)
					await this.$store.dispatch("alerts/success", "Secteur ajouté");
					this.$router.go(-1);
				} catch (e) {
					this.error = e.response.data.errors
				}
			} else {
				this.error = [{
					detail: 'Le nom du secteur ne peut pas être vide',
					source: { pointer: '/data/attributes/name' }
				}]
			}
		}
	},
}
</script>

<style scoped>

</style>
